
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 19","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 5.75a5 5 0 015-5v0a5 5 0 015 5v1H3v-1z","stroke":"currentColor","stroke-width":"1.5","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M.75 6.75h14.5V15A3.25 3.25 0 0112 18.25H4A3.25 3.25 0 01.75 15V6.75z","stroke":"currentColor","stroke-width":"1.5","stroke-miterlimit":"10"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"1.5","d":"M8 11v3"}})])
          )
        }
      }
    